import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { CashflowCsv } from './CashflowCsv';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PercentageFieldText } from '../../mui-overrides/Percentage';
import Grid from '@mui/material/Grid';
import { useFormikContext } from 'formik';
import { TAssetInvestmentDetailsSchema } from '@brickwise/asset-validation/dist/asset/investmentData';

interface ICashflowCsvProps {
  disabled: boolean;
}

export const CashFlow = ({ disabled }: ICashflowCsvProps) => {
  const { t } = useTranslation();
  const formik = useFormikContext<TAssetInvestmentDetailsSchema>();

  return (
    <>
      <LaunchpadCard title={t('dashboard.assets.addedit.investmentDetails.cashFlowTable.title')}>
        <Typography variant="body1">{t('dashboard.assets.addedit.investmentDetails.cashFlowTable.description1')}</Typography>
        <Typography variant="body1" sx={{ marginBottom: 3 }}>
          {t('dashboard.assets.addedit.investmentDetails.cashFlowTable.description2')}
        </Typography>
        <Grid container sx={{ mb: 3 }} spacing={2}>
          <Grid md={6} xs={12} alignItems="center">
            <PercentageFieldText
              label={t('dashboard.assets.addedit.investmentDetails.cashFlowTable.estimatedRentIndexationField.label')}
              formik={formik}
              disabled={disabled}
              fieldName="investmentDetails.estimatedRentIndexation"
              hideHelperText
              size="small"
              margin="none"
            />
          </Grid>
        </Grid>
        <CashflowCsv disabled={disabled} scenario="normal" />
        <CashflowCsv disabled={disabled} scenario="optimistic" />
        <CashflowCsv disabled={disabled} scenario="stress" />
      </LaunchpadCard>
    </>
  );
};
